import React from 'react'
import "./index.css";
import DotGrid from './components/DotGrid';
import FuzzyText from './ui/FuzzyText';
import About from './components/About';
import SponsorsSection from './components/SponsorSection';
import HackTimeline from './components/HackTimeline';
import JudgingCriteria from './components/JudgingCriteria';
import PrizesRewards from './components/PrizeCard'; // Changed to match the export name

function App() {
  

  return (
    <div style={{background: 'black', color: '#FF3131'}}>
      <div style={{ width: '100%', height: '600px', position: 'relative', background: 'black' }}>
  <DotGrid
    dotSize={3}
    gap={5}
    baseColor="#ff3131"
    activeColor="#085cf8ff"
    proximity={120}
    shockRadius={250}
    shockStrength={5}
    resistance={500}
    returnDuration={0.5}
  >
    {/* Overlay text */}
    <div
      style={{
        position: 'absolute',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        pointerEvents: 'none', // important
        zIndex: 10
      }}
    >
<div className="flex flex-col items-center text-center">
  <div className="block text-white font-extrabold text-2xl md:text-1xl mb-6">
    ASTRANOVA&apos;s
  </div>

  <FuzzyText  
    color="#FF3131"
    baseIntensity={0.2}
    hoverIntensity={0}
    enableHover={true}
  >
    The Grid
  </FuzzyText>

  <div className="flex flex-col items-center text-center">
  <div className="block text-white font-extrabold text-2xl md:text-1xl mb-6">
    National Level Hackathon
  </div>
  </div>
</div>

    </div>
  </DotGrid>
  
</div>
<About /> {/* Removed empty children */}
<SponsorsSection/>
<HackTimeline/>
<JudgingCriteria/>
<PrizesRewards /> {/* Changed to match export name */}
</div>
  )
}

export default App